import './UsageInfo.scss';
import DOMPurify from 'dompurify';
import { ParameterModel } from 'types/trackmanParameters';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

type Props = {
  visibleParameter: ParameterModel;
};

export const UsageInfo = ({ visibleParameter }: Props) => {
  const { t } = useTranslation();

  return (
    <div className='usage-info'>
      <h3>{t('WhatIsItUsedFor', { ns: 'trackmanParameters' })}</h3>
      <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(visibleParameter.usageInfo) }} />
    </div>
  );
};

export default UsageInfo;
